document.addEventListener("DOMContentLoaded", () => {
  const isHoverable = window.matchMedia("(hover: hover)").matches;

  const ctaButtonWrapper = document.querySelector(".cta-button");
  const ctaButton = ctaButtonWrapper?.querySelector(".button");
  if (
    ctaButton &&
    !isHoverable &&
    ctaButtonWrapper.querySelector(".child-links")
  ) {
    // If there is no hover event and the cta button has child links, prevent default on the main button click
    ctaButton.addEventListener("click", (e) => {
      e.preventDefault();
    });
  }
});
